module.exports = __webpack_public_path__ + "static/img/class.7b28784d.png";